import styled from "styled-components";
import { grid } from "styled-system";

import Box from "../Box";

const Grid = styled(Box)({ display: "grid" }, grid);

export default Grid;
